// src/main.js
import { createApp } from 'vue'
import App from './App.vue'

// CSS-ek – EZEKBŐL áll össze a dist/style.css
import 'bootstrap/dist/css/bootstrap.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './style.css' // a saját teljes CSS-ed

// JS – Bootstrap (Popper-rel), jQuery nem kell
import 'bootstrap/dist/js/bootstrap.bundle'

const app = createApp(App)

// ha raktunk $filters-t korábban, azt itt add vissza
const filters = {
    monthesAndYears(n) {
        const x = Number(n||0), m = x % 12, y = Math.floor(x/12)
        return [y && `${y} év`, m && `${m} hónap`].filter(Boolean).join(' ')
    },
    formatPrice(v) {
        const num = Number(String(v??0).replace(/\s/g,''))||0
        return new Intl.NumberFormat('hu-HU', { maximumFractionDigits: 0 }).format(num)
    }
}
app.config.globalProperties.$filters = filters
app.provide('filters', filters)

app.mount('#app')
